const PL = 'pl';

function capitalizeToken(token: string): string {
	if (!token || !/[a-zA-Z\u0100-\u024F]/.test(token)) {
		return token;
	}
	const lower = token.toLocaleLowerCase(PL);
	return lower.charAt(0).toLocaleUpperCase(PL) + lower.slice(1);
}

/** Imię / nazwisko: pierwsza litera każdego wyrazu i części po myślniku wielka (locale pl). */
export function formatPersonName(value: string): string {
	return value
		.trim()
		.split(/\s+/)
		.filter(Boolean)
		.map((word) =>
			word
				.split('-')
				.map((part) =>
					part
						.split("'")
						.map((subPart) => capitalizeToken(subPart))
						.join("'"),
				)
				.join('-'),
		)
		.join(' ');
}
